<template>
  <ul class="tree-menu">
    <li class="tree-menu-list">
      <div class="group-node" :style="indent" :id="group.id">
        <span></span>
        <div class="grounp-content" @click="nodeCheck(group)">
          <!-- <div class="ground-floor"></div> -->
          <span
            class="list-handle"
            v-if="(group.children && group.children.length) || (group. sub_category && group. sub_category.length)"
            @click.stop="expandHandle = !expandHandle"
          >
            <i :class="expandHandle ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
          </span>
          <!-- <el-checkbox v-model= "group.checked" :indeterminate="group.isIndeterminate" @change="handleCheck(group)"/> -->
          <span>{{group.name}}</span>
        </div>
      </div>

      <el-collapse-transition>
        <ol class="group-children" v-if="expandHandle">
          <tree-menu
            v-for="item in group.children || group. sub_category"
            @nodeCheck="nodeCheck"
            :defaultExpand="expand"
            :isGroup="isGroup"
            :group="item"
            :depth="depth + 1"
            :key="item.id"
          ></tree-menu>
        </ol>
      </el-collapse-transition>
    </li>
  </ul>
</template>
      
      <script>
export default {
  props: {
    group: Object,
    depth: Number,
    isGroup: Boolean,
    defaultExpand: {
      type: Boolean,
      default: false
    }
  },
  name: "tree-menu",

  data() {
    return {
      expandHandle: this.defaultExpand,
      expand: this.defaultExpand
    };
  },
  computed: {
    indent() {
      return { paddingLeft: `${this.depth * 20}px` };
    }
  },
  methods: {
    nodeCheck(group) {
      // if ((!group.id && this.isGroup) || (!group.parent_id && this.isGroup)) return;
      if(!group.id || !group.parent_id) return;
      this.setBGcolor(group);
      this.$emit("nodeCheck", group);
    },
    // handleCheck(group){
    //     this.stopPropagation = false;

    //     this.$emit('handleCheck', group, group.checked)
    // },
    setBGcolor(group) {
      let arr = document.getElementsByClassName("group-node");
      for (let item of arr) {
        if (Number(item.id) === group.id) {
          if (!item.firstChild.className) {
            item.firstChild.className = "aa el-icon-check";
            group.check = true;
          }
        } else {
          item.firstChild.className = "";
        }
      }
    }
  },

  updated() {}
};
</script>

<style lang="scss" src="./index.scss" scoped>

</style>

